module.exports = __webpack_public_path__ + "908e4d2e/img/chevron-down-icon.5542f65c.svg";